import { useState } from "react";
import { footerColumns, siteMeta } from "@/mocks/home";

export default function SiteFooter() {
  const [report, setReport] = useState("");
  const [reportHint, setReportHint] = useState("");

  const handleReport = () => {
    const value = report.trim();
    if (!value) {
      setReportHint("请简要填写需要核对或纠正的档案编号");
      return;
    }
    setReportHint("已记录你的反馈，整理组会在核对来源后更新该条目");
    setReport("");
  };

  return (
    <footer id="footer" className="w-full bg-primary-800">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-archive-2-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteMeta.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-primary-100">
              一个以编号索引为核心的深度档案区。我们把背景挖掘、证据汇总与时间线放在同一处，方便你按自己的顺序阅读。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#footer"
                  aria-label="联系渠道"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-600/70 text-primary-100 transition-colors hover:border-background-50 hover:text-background-50"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-5">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-background-50">
                  {column.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#footer"
                        className="text-[13px] text-primary-100 transition-colors hover:text-background-50"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50">纠错通道</h4>
            <p className="mt-3 text-[13px] leading-6 text-primary-100">
              发现编号对应的来源标注有误，可以在这里留言，我们会附上修订记录。
            </p>
            <div className="mt-4 flex items-center rounded-md border border-primary-600/70 bg-primary-900/40">
              <input
                value={report}
                onChange={(event) => setReport(event.target.value)}
                placeholder="档案编号 / 说明"
                className="h-10 flex-1 bg-transparent px-3 text-sm text-background-50 outline-none placeholder:text-primary-200/70"
              />
              <button
                type="button"
                onClick={handleReport}
                className="mr-1 whitespace-nowrap rounded-md bg-accent-500 px-3.5 py-1.5 text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
              >
                提交
              </button>
            </div>
            {reportHint && (
              <p className="mt-2 flex items-center gap-1.5 text-xs text-accent-200">
                <i className="ri-checkbox-circle-line text-sm" />
                {reportHint}
              </p>
            )}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-600/60 pt-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteMeta.name} · 内容为公开渠道整理的资料索引，仅供查阅与核对。</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#footer" className="transition-colors hover:text-background-50">
              隐私与合规
            </a>
            <a href="#footer" className="transition-colors hover:text-background-50">
              免责声明
            </a>
            <a href="#top" className="flex items-center gap-1 transition-colors hover:text-background-50">
              返回顶部
              <i className="ri-arrow-up-line text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}